import "./ToggleOptions.scss"
import { Box } from "@mui/material"
import classNames from "classnames"
import React from "react"
import CustomCard from "./CustomCard"
import Text from "./Text"
import { useIsMobile } from "src/hooks/useIsMobile"

interface Props<T> {
  value: T
  onChange: (value: T) => void
  options: Array<{ label: string; value: T; icon?: string }>
}

function ToggleOptions<T>({ value, onChange, options }: Props<T>) {
  const isMobile = useIsMobile()
  const showIcon = !isMobile && options.length <= 5

  return (
    <Box>
      {options.map((option) => (
        <CustomCard
          variant="black"
          withGradient={value === option.value}
          key={option.label}
          onClick={() => onChange(option.value)}
          className={classNames("toggle-options", {
            selected: value === option.value,
          })}
          p={1}
          width={`${(100 / options.length).toFixed(2)}%`}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {showIcon && option.icon && <img src={option.icon} height={16} />}
            <Text size="small" ml={showIcon ? 0.5 : 0}>
              {option.label}
            </Text>
          </Box>
        </CustomCard>
      ))}
    </Box>
  )
}

export default ToggleOptions
